"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetV1PollsPollsScopeEnum = exports.PollApi = exports.PollApiFactory = exports.PollApiFp = exports.PollApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * PollApi - axios parameter creator
 */
const PollApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete all user polls for a user
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1PollsUserUserIdPollsDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('deleteV1PollsUserUserIdPollsDelete', 'userId', userId);
            const localVarPath = `/v1/polls/users/{user_id}/polls`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/users/{user_id}/polls`,
                sdkMethod: 'deleteV1PollsUserUserIdPollsDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| ||||
         * @summary Expunge all user polls for a user
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1PollsUserUserIdPollsExpunge: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('deleteV1PollsUserUserIdPollsExpunge', 'userId', userId);
            const localVarPath = `/v1/polls/users/{user_id}/polls/expunge`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/users/{user_id}/polls/expunge`,
                sdkMethod: 'deleteV1PollsUserUserIdPollsExpunge',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns the FTUE survey for guests
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1GuestFtuePoll: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ acceptLanguage }, options = {}) {
            const localVarPath = `/v1/polls/public/polls/ftue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/public/polls/ftue`,
                sdkMethod: 'getV1GuestFtuePoll',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary List polls
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {GetV1PollsPollsScopeEnum} [scope] The scope type of poll desired, default is \&#39;circle\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsPolls: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ acceptLanguage, scope }, options = {}) {
            const localVarPath = `/v1/polls/polls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/polls`,
                sdkMethod: 'getV1PollsPolls',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves a poll with a well-known string identifier. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get a poll by known identifier
         * @param {string} pollId Poll ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsPollsPollId: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ pollId }, options = {}) {
            // verify required parameter 'pollId' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsPollsPollId', 'pollId', pollId);
            const localVarPath = `/v1/polls/polls/{poll_id}`.replace('{poll_id}', encodeURIComponent(String(pollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/polls/{poll_id}`,
                sdkMethod: 'getV1PollsPollsPollId',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve the recorded polls for the given poll ID and recipient ID. They will be sorted from most recent to least recent. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get recorded polls with identifier for recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} pollId Poll ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} [limit] Limit for pagination
         * @param {boolean} [completed] Filter polls by completed status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsRecipientsRecipientIdPollPollId: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, pollId, circleAuthorizationToken, limit, completed, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsRecipientsRecipientIdPollPollId', 'recipientId', recipientId);
            // verify required parameter 'pollId' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsRecipientsRecipientIdPollPollId', 'pollId', pollId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsRecipientsRecipientIdPollPollId', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/polls/recipients/{recipient_id}/polls/{poll_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{poll_id}', encodeURIComponent(String(pollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (completed !== undefined) {
                localVarQueryParameter['completed'] = completed;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/recipients/{recipient_id}/polls/{poll_id}`,
                sdkMethod: 'getV1PollsRecipientsRecipientIdPollPollId',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves a poll with a well-known string identifier for given recipient. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get a poll by known identifier for given recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} pollId Poll ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsRecipientsRecipientIdPollPollIdConfig: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, pollId, circleAuthorizationToken, acceptLanguage, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsRecipientsRecipientIdPollPollIdConfig', 'recipientId', recipientId);
            // verify required parameter 'pollId' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsRecipientsRecipientIdPollPollIdConfig', 'pollId', pollId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsRecipientsRecipientIdPollPollIdConfig', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/polls/recipients/{recipient_id}/polls/{poll_id}/config`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{poll_id}', encodeURIComponent(String(pollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/recipients/{recipient_id}/polls/{poll_id}/config`,
                sdkMethod: 'getV1PollsRecipientsRecipientIdPollPollIdConfig',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve the latest recorded polls for the given recipient ID. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get latest recorded polls for recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsRecipientsRecipientIdPolls: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsRecipientsRecipientIdPolls', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsRecipientsRecipientIdPolls', 'recipientId', recipientId);
            const localVarPath = `/v1/polls/recipients/{recipient_id}/polls`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/recipients/{recipient_id}/polls`,
                sdkMethod: 'getV1PollsRecipientsRecipientIdPolls',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get latest recorded user polls
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsUserUserIdPolls: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsUserUserIdPolls', 'userId', userId);
            const localVarPath = `/v1/polls/users/{user_id}/polls`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/users/{user_id}/polls`,
                sdkMethod: 'getV1PollsUserUserIdPolls',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get user recorded poll by known identifier
         * @param {string} userId User ID
         * @param {string} pollId Poll ID
         * @param {number} [limit] Limit for pagination
         * @param {boolean} [completed] Filter polls by completed status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsUserUserIdPollsPollId: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, pollId, limit, completed, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsUserUserIdPollsPollId', 'userId', userId);
            // verify required parameter 'pollId' is not null or undefined
            (0, common_1.assertParamExists)('getV1PollsUserUserIdPollsPollId', 'pollId', pollId);
            const localVarPath = `/v1/polls/users/{user_id}/polls/{poll_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{poll_id}', encodeURIComponent(String(pollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (completed !== undefined) {
                localVarQueryParameter['completed'] = completed;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/users/{user_id}/polls/{poll_id}`,
                sdkMethod: 'getV1PollsUserUserIdPollsPollId',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | poll | poll | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {PollRecipientCopyRequest} [pollRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollCopyDataToNewRecipientV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, pollRecipientCopyRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('pollCopyDataToNewRecipientV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('pollCopyDataToNewRecipientV1', 'recipientId', recipientId);
            const localVarPath = `/v1/polls/recipients/{recipient_id}/copy`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/recipients/{recipient_id}/copy`,
                sdkMethod: 'pollCopyDataToNewRecipientV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pollRecipientCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Soft delete every recorded recipient poll and the associated answers. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|d|
         * @summary Delete every recorded recipient poll and answers
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollsDeleteV1PollsRecipientsRecipientId: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('pollsDeleteV1PollsRecipientsRecipientId', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('pollsDeleteV1PollsRecipientsRecipientId', 'recipientId', recipientId);
            const localVarPath = `/v1/polls/recipients/{recipient_id}`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/recipients/{recipient_id}`,
                sdkMethod: 'pollsDeleteV1PollsRecipientsRecipientId',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Hard delete every recorded recipient poll and the associated answers. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|e|
         * @summary Delete every recorded recipient poll and answers permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge', 'recipientId', recipientId);
            const localVarPath = `/v1/polls/recipients/{recipient_id}/polls/expunge`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/recipients/{recipient_id}/polls/expunge`,
                sdkMethod: 'pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Save a recorded poll for the given recipient and poll ID. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|c|
         * @summary Save recorded poll with identifier for recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} pollId Poll ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {PollCreateRecordedPollRequest} [pollCreateRecordedPollRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1PollsRecipientsRecipientIdPollPollId: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, pollId, circleAuthorizationToken, pollCreateRecordedPollRequest, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('postV1PollsRecipientsRecipientIdPollPollId', 'recipientId', recipientId);
            // verify required parameter 'pollId' is not null or undefined
            (0, common_1.assertParamExists)('postV1PollsRecipientsRecipientIdPollPollId', 'pollId', pollId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('postV1PollsRecipientsRecipientIdPollPollId', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/polls/recipients/{recipient_id}/polls/{poll_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{poll_id}', encodeURIComponent(String(pollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/recipients/{recipient_id}/polls/{poll_id}`,
                sdkMethod: 'postV1PollsRecipientsRecipientIdPollPollId',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pollCreateRecordedPollRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Save user recorded poll
         * @param {string} userId User ID
         * @param {string} pollId Poll ID
         * @param {number} [limit] Limit for pagination
         * @param {boolean} [completed] Filter polls by completed status.
         * @param {PollCreateRecordedPollRequest} [pollCreateRecordedPollRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1PollsUserUserIdPollsPollId: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, pollId, limit, completed, pollCreateRecordedPollRequest, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('postV1PollsUserUserIdPollsPollId', 'userId', userId);
            // verify required parameter 'pollId' is not null or undefined
            (0, common_1.assertParamExists)('postV1PollsUserUserIdPollsPollId', 'pollId', pollId);
            const localVarPath = `/v1/polls/users/{user_id}/polls/{poll_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{poll_id}', encodeURIComponent(String(pollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (completed !== undefined) {
                localVarQueryParameter['completed'] = completed;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/users/{user_id}/polls/{poll_id}`,
                sdkMethod: 'postV1PollsUserUserIdPollsPollId',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pollCreateRecordedPollRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get static content for polls
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v1GetPollStaticContent: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ acceptLanguage }, options = {}) {
            const localVarPath = `/v1/polls/content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/polls/content`,
                sdkMethod: 'v1GetPollStaticContent',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get static content for polls
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPollStaticContent: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPollStaticContent', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPollStaticContent', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v2/polls/content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/polls/content`,
                sdkMethod: 'v2GetPollStaticContent',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PollApiAxiosParamCreator = PollApiAxiosParamCreator;
/**
 * PollApi - functional programming interface
 */
const PollApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PollApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete all user polls for a user
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1PollsUserUserIdPollsDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteV1PollsUserUserIdPollsDelete(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.deleteV1PollsUserUserIdPollsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| ||||
         * @summary Expunge all user polls for a user
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1PollsUserUserIdPollsExpunge(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteV1PollsUserUserIdPollsExpunge(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.deleteV1PollsUserUserIdPollsExpunge']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Returns the FTUE survey for guests
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1GuestFtuePoll(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1GuestFtuePoll(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.getV1GuestFtuePoll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary List polls
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {GetV1PollsPollsScopeEnum} [scope] The scope type of poll desired, default is \&#39;circle\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsPolls(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1PollsPolls(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.getV1PollsPolls']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves a poll with a well-known string identifier. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get a poll by known identifier
         * @param {string} pollId Poll ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsPollsPollId(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1PollsPollsPollId(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.getV1PollsPollsPollId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve the recorded polls for the given poll ID and recipient ID. They will be sorted from most recent to least recent. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get recorded polls with identifier for recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} pollId Poll ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} [limit] Limit for pagination
         * @param {boolean} [completed] Filter polls by completed status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsRecipientsRecipientIdPollPollId(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1PollsRecipientsRecipientIdPollPollId(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.getV1PollsRecipientsRecipientIdPollPollId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves a poll with a well-known string identifier for given recipient. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get a poll by known identifier for given recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} pollId Poll ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsRecipientsRecipientIdPollPollIdConfig(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1PollsRecipientsRecipientIdPollPollIdConfig(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.getV1PollsRecipientsRecipientIdPollPollIdConfig']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve the latest recorded polls for the given recipient ID. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get latest recorded polls for recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsRecipientsRecipientIdPolls(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1PollsRecipientsRecipientIdPolls(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.getV1PollsRecipientsRecipientIdPolls']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get latest recorded user polls
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsUserUserIdPolls(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1PollsUserUserIdPolls(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.getV1PollsUserUserIdPolls']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get user recorded poll by known identifier
         * @param {string} userId User ID
         * @param {string} pollId Poll ID
         * @param {number} [limit] Limit for pagination
         * @param {boolean} [completed] Filter polls by completed status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsUserUserIdPollsPollId(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1PollsUserUserIdPollsPollId(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.getV1PollsUserUserIdPollsPollId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | poll | poll | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {PollRecipientCopyRequest} [pollRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollCopyDataToNewRecipientV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pollCopyDataToNewRecipientV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.pollCopyDataToNewRecipientV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Soft delete every recorded recipient poll and the associated answers. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|d|
         * @summary Delete every recorded recipient poll and answers
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollsDeleteV1PollsRecipientsRecipientId(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pollsDeleteV1PollsRecipientsRecipientId(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.pollsDeleteV1PollsRecipientsRecipientId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Hard delete every recorded recipient poll and the associated answers. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|e|
         * @summary Delete every recorded recipient poll and answers permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Save a recorded poll for the given recipient and poll ID. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|c|
         * @summary Save recorded poll with identifier for recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} pollId Poll ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {PollCreateRecordedPollRequest} [pollCreateRecordedPollRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1PollsRecipientsRecipientIdPollPollId(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postV1PollsRecipientsRecipientIdPollPollId(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.postV1PollsRecipientsRecipientIdPollPollId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Save user recorded poll
         * @param {string} userId User ID
         * @param {string} pollId Poll ID
         * @param {number} [limit] Limit for pagination
         * @param {boolean} [completed] Filter polls by completed status.
         * @param {PollCreateRecordedPollRequest} [pollCreateRecordedPollRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1PollsUserUserIdPollsPollId(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postV1PollsUserUserIdPollsPollId(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.postV1PollsUserUserIdPollsPollId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get static content for polls
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v1GetPollStaticContent(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetPollStaticContent(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.v1GetPollStaticContent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get static content for polls
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPollStaticContent(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetPollStaticContent(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PollApi.v2GetPollStaticContent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PollApiFp = PollApiFp;
/**
 * PollApi - factory interface
 */
const PollApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PollApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete all user polls for a user
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1PollsUserUserIdPollsDelete(params, options) {
            return localVarFp
                .deleteV1PollsUserUserIdPollsDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| ||||
         * @summary Expunge all user polls for a user
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1PollsUserUserIdPollsExpunge(params, options) {
            return localVarFp
                .deleteV1PollsUserUserIdPollsExpunge(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the FTUE survey for guests
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1GuestFtuePoll(params, options) {
            return localVarFp
                .getV1GuestFtuePoll(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary List polls
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {GetV1PollsPollsScopeEnum} [scope] The scope type of poll desired, default is \&#39;circle\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsPolls(params, options) {
            return localVarFp
                .getV1PollsPolls(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a poll with a well-known string identifier. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get a poll by known identifier
         * @param {string} pollId Poll ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsPollsPollId(params, options) {
            return localVarFp
                .getV1PollsPollsPollId(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the recorded polls for the given poll ID and recipient ID. They will be sorted from most recent to least recent. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get recorded polls with identifier for recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} pollId Poll ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} [limit] Limit for pagination
         * @param {boolean} [completed] Filter polls by completed status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsRecipientsRecipientIdPollPollId(params, options) {
            return localVarFp
                .getV1PollsRecipientsRecipientIdPollPollId(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a poll with a well-known string identifier for given recipient. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get a poll by known identifier for given recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} pollId Poll ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsRecipientsRecipientIdPollPollIdConfig(params, options) {
            return localVarFp
                .getV1PollsRecipientsRecipientIdPollPollIdConfig(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the latest recorded polls for the given recipient ID. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get latest recorded polls for recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsRecipientsRecipientIdPolls(params, options) {
            return localVarFp
                .getV1PollsRecipientsRecipientIdPolls(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get latest recorded user polls
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsUserUserIdPolls(params, options) {
            return localVarFp
                .getV1PollsUserUserIdPolls(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get user recorded poll by known identifier
         * @param {string} userId User ID
         * @param {string} pollId Poll ID
         * @param {number} [limit] Limit for pagination
         * @param {boolean} [completed] Filter polls by completed status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1PollsUserUserIdPollsPollId(params, options) {
            return localVarFp
                .getV1PollsUserUserIdPollsPollId(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | poll | poll | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {PollRecipientCopyRequest} [pollRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollCopyDataToNewRecipientV1(params, options) {
            return localVarFp
                .pollCopyDataToNewRecipientV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft delete every recorded recipient poll and the associated answers. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|d|
         * @summary Delete every recorded recipient poll and answers
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollsDeleteV1PollsRecipientsRecipientId(params, options) {
            return localVarFp
                .pollsDeleteV1PollsRecipientsRecipientId(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Hard delete every recorded recipient poll and the associated answers. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|e|
         * @summary Delete every recorded recipient poll and answers permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge(params, options) {
            return localVarFp
                .pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Save a recorded poll for the given recipient and poll ID. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|c|
         * @summary Save recorded poll with identifier for recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} pollId Poll ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {PollCreateRecordedPollRequest} [pollCreateRecordedPollRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1PollsRecipientsRecipientIdPollPollId(params, options) {
            return localVarFp
                .postV1PollsRecipientsRecipientIdPollPollId(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Save user recorded poll
         * @param {string} userId User ID
         * @param {string} pollId Poll ID
         * @param {number} [limit] Limit for pagination
         * @param {boolean} [completed] Filter polls by completed status.
         * @param {PollCreateRecordedPollRequest} [pollCreateRecordedPollRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1PollsUserUserIdPollsPollId(params, options) {
            return localVarFp
                .postV1PollsUserUserIdPollsPollId(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get static content for polls
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v1GetPollStaticContent(params, options) {
            return localVarFp
                .v1GetPollStaticContent(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
         * @summary Get static content for polls
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPollStaticContent(params, options) {
            return localVarFp
                .v2GetPollStaticContent(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.PollApiFactory = PollApiFactory;
/**
 * PollApi - object-oriented interface
 */
class PollApi extends base_1.BaseAPI {
    /**
     * URL `/v1/polls/users/{user_id}/polls`
     *
     * @summary Delete all user polls for a user
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteV1PollsUserUserIdPollsDelete(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .deleteV1PollsUserUserIdPollsDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/users/{user_id}/polls/expunge`
     * |Feature|Dataclass|Permission| |-------|---------|----------| ||||
     * @summary Expunge all user polls for a user
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteV1PollsUserUserIdPollsExpunge(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .deleteV1PollsUserUserIdPollsExpunge(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/public/polls/ftue`
     *
     * @summary Returns the FTUE survey for guests
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getV1GuestFtuePoll(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .getV1GuestFtuePoll(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/polls`
     * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
     * @summary List polls
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {GetV1PollsPollsScopeEnum} [scope] The scope type of poll desired, default is \&#39;circle\&#39;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getV1PollsPolls(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .getV1PollsPolls(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/polls/{poll_id}`
     * Retrieves a poll with a well-known string identifier. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
     * @summary Get a poll by known identifier
     * @param {string} pollId Poll ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getV1PollsPollsPollId(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .getV1PollsPollsPollId(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/recipients/{recipient_id}/polls/{poll_id}`
     * Retrieve the recorded polls for the given poll ID and recipient ID. They will be sorted from most recent to least recent. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
     * @summary Get recorded polls with identifier for recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} pollId Poll ID
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} [limit] Limit for pagination
     * @param {boolean} [completed] Filter polls by completed status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getV1PollsRecipientsRecipientIdPollPollId(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .getV1PollsRecipientsRecipientIdPollPollId(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/recipients/{recipient_id}/polls/{poll_id}/config`
     * Retrieves a poll with a well-known string identifier for given recipient. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
     * @summary Get a poll by known identifier for given recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} pollId Poll ID
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getV1PollsRecipientsRecipientIdPollPollIdConfig(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .getV1PollsRecipientsRecipientIdPollPollIdConfig(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/recipients/{recipient_id}/polls`
     * Retrieve the latest recorded polls for the given recipient ID. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
     * @summary Get latest recorded polls for recipient
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getV1PollsRecipientsRecipientIdPolls(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .getV1PollsRecipientsRecipientIdPolls(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/users/{user_id}/polls`
     *
     * @summary Get latest recorded user polls
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getV1PollsUserUserIdPolls(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .getV1PollsUserUserIdPolls(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/users/{user_id}/polls/{poll_id}`
     *
     * @summary Get user recorded poll by known identifier
     * @param {string} userId User ID
     * @param {string} pollId Poll ID
     * @param {number} [limit] Limit for pagination
     * @param {boolean} [completed] Filter polls by completed status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getV1PollsUserUserIdPollsPollId(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .getV1PollsUserUserIdPollsPollId(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/recipients/{recipient_id}/copy`
     * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | poll | poll | c |
     * @summary v1 Copy Data To New Recipient
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {PollRecipientCopyRequest} [pollRecipientCopyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollCopyDataToNewRecipientV1(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .pollCopyDataToNewRecipientV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/recipients/{recipient_id}`
     * Soft delete every recorded recipient poll and the associated answers. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|d|
     * @summary Delete every recorded recipient poll and answers
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollsDeleteV1PollsRecipientsRecipientId(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .pollsDeleteV1PollsRecipientsRecipientId(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/recipients/{recipient_id}/polls/expunge`
     * Hard delete every recorded recipient poll and the associated answers. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|e|
     * @summary Delete every recorded recipient poll and answers permanently.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .pollsDeleteV1PollsRecipientsRecipientIdPollsExpunge(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/recipients/{recipient_id}/polls/{poll_id}`
     * Save a recorded poll for the given recipient and poll ID. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|c|
     * @summary Save recorded poll with identifier for recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} pollId Poll ID
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {PollCreateRecordedPollRequest} [pollCreateRecordedPollRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postV1PollsRecipientsRecipientIdPollPollId(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .postV1PollsRecipientsRecipientIdPollPollId(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/users/{user_id}/polls/{poll_id}`
     *
     * @summary Save user recorded poll
     * @param {string} userId User ID
     * @param {string} pollId Poll ID
     * @param {number} [limit] Limit for pagination
     * @param {boolean} [completed] Filter polls by completed status.
     * @param {PollCreateRecordedPollRequest} [pollCreateRecordedPollRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postV1PollsUserUserIdPollsPollId(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .postV1PollsUserUserIdPollsPollId(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/polls/content`
     * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
     * @summary Get static content for polls
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    v1GetPollStaticContent(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .v1GetPollStaticContent(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/polls/content`
     * List polls. |Feature|Dataclass|Permission| |-------|---------|----------| |poll|poll|r|
     * @summary Get static content for polls
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2GetPollStaticContent(params, options) {
        return (0, exports.PollApiFp)(this.configuration)
            .v2GetPollStaticContent(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.PollApi = PollApi;
exports.GetV1PollsPollsScopeEnum = {
    User: 'user',
    Circle: 'circle',
};
//# sourceMappingURL=poll-api.js.map